import type { StatsigOptions } from '@statsig/react-bindings';

const PROXY_BASE_URLS: Record<string, string> = {
  staging: 'https://growtherapystaging.com/statsig',
  production: 'https://growtherapy.com/statsig',
};

export function getStatsigProxyConfig(environment: string): StatsigOptions['networkConfig'] | undefined {
  const baseUrl = PROXY_BASE_URLS[environment];
  if (!baseUrl) return undefined;

  return {
    api: baseUrl,
    initializeUrl: `${baseUrl}/grow-config`,
    logEventUrl: `${baseUrl}/grow-analytics`,
  };
}
